import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Homepage from './pages/Homepage';
import CategorieProdotti from './pages/CategorieProdotti';
import CategoriaPage from './pages/CategoriaPage';
import ProdottoPage from './pages/ProdottoPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import './index.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/categorie" element={<CategorieProdotti />} />
        <Route path="/categoria/:slug" element={<CategoriaPage />} />
        <Route path="/prodotto/:id" element={<ProdottoPage />} />
        <Route path="/contatti" element={<Homepage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
    </BrowserRouter>
  );
}
